




















































































































































































































































import { ref, defineComponent, computed } from '@vue/composition-api';
import { DialogTypeEnum } from '../type';
import { applyBind, operateUserBind, dissolveTeam, changePasswd } from '@/services/accountManage/userGroup';
import graphicCodeHook from '@/views/patient/hooks/graphicCode';
import { getPassWordScore } from '@/utils/utils';
import { md5 } from 'md5js';
export default defineComponent({
  props: {
    dialogType: {
      type: String,
      default: '',
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    dialogContent: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit, root }: any) {
    const cancelDialogCB = () => {
      emit('cancelDialogCB');
    };
    const confirmDialogCB = () => {
      emit('confirmDialogCB');
    };
    const confirmRelation = async () => {
      await applyBind({
        userId: props.dialogContent?.userId,
      });
      root.$message({
        message: '已发送，等待对方同意',
        type: 'success',
      });
      confirmDialogCB();
    };
    const noPassword = computed(() => props.userInfo?.noPassword === 'Y');
    const confirmBind = async () => {
      await operateUserBind({
        userId: props.dialogContent?.userId,
        operation: 1,
      });
      confirmDialogCB();
    };
    const rejectReason = ref('');
    const confirmRefuse = async () => {
      await operateUserBind({
        userId: props.dialogContent?.userId,
        operation: 2,
        rejectReason: rejectReason.value,
      });
      confirmDialogCB();
    };
    const confirmUnbind = async () => {
      await operateUserBind({
        userId: props.dialogContent?.userId,
        operation: 3,
      });
      confirmDialogCB();
    };
    const confirmBindTips = async () => {
      root.$router.push({
        path: '/default/accountManage',
      });
      confirmDialogCB();
    };
    const confirmDissolve = async () => {
      await dissolveTeam();
      confirmDialogCB();
    };
    const { getCode, codeUid, graphicCode } = graphicCodeHook();
    const newPassword = ref('');
    const password = ref('');
    const secondaryPassword = ref('');
    const code = ref('');
    const passwordStrength = computed(() => getPassWordScore(newPassword.value));
    const modifyPasswordError = computed(() => {
      let errMsg = '';
      if (!noPassword.value && !password.value) {
        errMsg = '未填原密码';
      } else if (passwordStrength.value < 6) {
        errMsg = '新密码安全性太弱';
      } else if (newPassword.value !== secondaryPassword.value) {
        errMsg = '两次密码不一致';
      } else if (newPassword.value !== secondaryPassword.value) {
        errMsg = '未填验证码';
      } else if (newPassword.value === props.dialogContent.userName) {
        errMsg = '新密码不能和用户名相同';
      }
      return errMsg;
    });
    const confirmModify = async () => {
      if (modifyPasswordError.value) {
        return root.$toast(modifyPasswordError.value);
      }
      console.log(await changePasswd({
        password: noPassword.value ? '' : md5(password.value, 32),
        newPassword: md5(newPassword.value, 32),
        uid: codeUid.value,
        code: code.value,
      }));
      confirmDialogCB();
    };
    getCode();
    return {
      DialogTypeEnum,
      cancelDialogCB,
      confirmDialogCB,
      confirmRelation,
      rejectReason,
      confirmRefuse,
      confirmBind,
      confirmUnbind,
      confirmBindTips,
      confirmDissolve,
      getCode,
      codeUid,
      graphicCode,
      password,
      newPassword,
      secondaryPassword,
      passwordStrength,
      code,
      modifyPasswordError,
      confirmModify,
      noPassword,
    };
  },
});
